import { render, staticRenderFns } from "./ModalSuccessClaim.vue?vue&type=template&id=2761ddbc&scoped=true&"
import script from "./ModalSuccessClaim.vue?vue&type=script&lang=js&"
export * from "./ModalSuccessClaim.vue?vue&type=script&lang=js&"
import style0 from "./ModalSuccessClaim.vue?vue&type=style&index=0&id=2761ddbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2761ddbc",
  null
  
)

export default component.exports